module.exports = __webpack_public_path__ + "media/images/gateway/bitcoin-pay-3fd6ef9d0e2ead2437da820d02fb80b9.jpg";